import { useIntl } from "react-intl";
import { Link } from "react-router";
import orcidIcon from "@/assets/orcid-id.svg";
import { cn } from "@/utils/tailwind";

interface Props {
  orcid: string;
  /** `icon` shows the iD icon alone, `compact` follows it with the iD. */
  variant?: "icon" | "compact";
  className?: string;
}

/** A verified ORCID iD, shown the way ORCID's display guidelines ask: always
 * with the green iD icon, which only authenticated iDs may use. */
export default function OrcidId({
  orcid,
  variant = "compact",
  className,
}: Props) {
  const intl = useIntl();
  return (
    <Link
      to={`https://orcid.org/${orcid}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={intl.formatMessage({ defaultMessage: "View ORCID record" })}
      className={cn("inline-flex items-center gap-1", className)}
    >
      <img
        src={orcidIcon}
        alt={intl.formatMessage({ defaultMessage: "ORCID iD" })}
        className="size-4 shrink-0"
      />
      {variant === "compact" && <span className="font-mono">{orcid}</span>}
    </Link>
  );
}
